import styled from "@emotion/styled";
import { Colors } from "theme/colors";

export const StyledWarning = styled.div`
  font-size: 0.9375rem;
  margin-top: 0.62rem;
  color: ${Colors.RED};
`;
